import { useQuery } from '@tanstack/react-query';
import { pipelineApi } from '../api/pipeline.api';
import { processExpertiseData } from '../utils/pipelineHelpers';
import { ExpertiseData } from '../types/pipeline.types';

export const usePipelineData = () => {
  return useQuery<ExpertiseData[], Error>({
    queryKey: ['pipeline', 'expertises'],
    queryFn: async () => {
      const response = await pipelineApi.getAllExpertiseData();
      
      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch expertise data');
      }
      
      // Process the data to add stage information and urgency
      return processExpertiseData(response.data);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 30 * 1000, // Refetch every 30 seconds for real-time updates
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};